/**
 * IANA time zone of the runtime: the user's system zone in a browser, `UTC` on Lambda.
 * Same value as `Temporal.Now.timeZoneId()`, which `today()` defaults to.
 */
export const getLocalTimeZone = (): string => Intl.DateTimeFormat().resolvedOptions().timeZone;
